export default [
  {
    image: "images/brand-01.png",
  },
  {
    image: "images/brand-02.png",
  },
  {
    image: "images/brand-03.png",
  },
  {
    image: "images/brand-04.png",
  },
  {
    image: "images/brand-05.png",
  },
  {
    image: "images/brand-06.png",
  },
  {
    image: "images/brand-07.png",
  },
  {
    image: "images/brand-08.png",
  },
];
